import {createStore} from "vuex";
import {authModule} from "./authModule.js";
import {navbarModule} from "./navbarModule.js";
import {errorModule} from "./errorModule.js";

export default createStore({
    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    },

    modules: {
        auth: authModule,
        navbar: navbarModule,
        error: errorModule,
    }
})
